if (document.readyState!='loading') {                                   // in case the document is already rendered
    loadTimedContent(null);
} else if (document.addEventListener) {                                 // modern browsers
    document.addEventListener('DOMContentLoaded', loadTimedContent);
} else document.attachEvent('onreadystatechange', function(){           // IE <= 8
    if (document.readyState=='complete') {
        loadTimedContent();
    }
});

function loadTimedContent(event) {
    var timedContent = Array.prototype.slice.call(document.getElementsByClassName('timed-content'));

    if (timedContent.length > 0) {
        var currentDate;
        try {
            currentDate = new Date(new Date().toLocaleString("en-US", {timeZone: "Australia/Melbourne"}));
        } catch(e) {
            currentDate = new Date(new Date().toLocaleString("en-US"));
        }

        for (i = 0; i < timedContent.length; i++) {
            var content = timedContent[i];
            var publish = content.dataset.publish;
            var expire = content.dataset.expire;
            var remove = false;

            if (publish !== "") {
                var publishDate = new Date(publish);

                if (currentDate >= publishDate) {
                    content.classList.remove('timed-content');
                } else {
                    remove = true;
                }
            } else {
                content.classList.remove('timed-content');
            }

            if (expire !== "") {
                var expireDate = new Date(expire);

                if (currentDate < expireDate) {
                    content.classList.remove('timed-content');
                } else {
                    remove = true;
                }
            } else {
                content.classList.remove('timed-content');
            }

            if (remove) {
                try {
                    content.remove();
                } catch(e) {
                  	console.error("Couldn't remove content");
                    // content.parentElement.removeChild(content);
                }
            }
        }
    }
}